import SiteLayout from '@/components/feature/SiteLayout';
import { usePageMeta } from '@/hooks/usePageMeta';
import HeroSection from '@/pages/home/components/HeroSection';
import CategoryEntries from '@/pages/home/components/CategoryEntries';
import LatestNews from '@/pages/home/components/LatestNews';
import PlotPreview from '@/pages/home/components/PlotPreview';
import CastStrip from '@/pages/home/components/CastStrip';
import SiteIntro from '@/pages/home/components/SiteIntro';

export default function Home() {
  usePageMeta({
    title: '禁止的爱善良的小姨子电视剧剧情介绍与专题',
    description:
      '禁止的爱善良的小姨子专题网站，提供该电视剧的剧情介绍、演员信息及最新动态，帮助观众深入了解剧集内容。',
    keywords: '禁止的爱善良的小姨子,电视剧,剧情介绍,演员名单,影视专题。',
  });

  return (
    <SiteLayout>
      <HeroSection />
      <CategoryEntries />
      <LatestNews />
      <PlotPreview />
      <CastStrip />
      <SiteIntro />
    </SiteLayout>
  );
}